import { matchPath, useLocation } from 'react-router';
import { useMemo } from 'react';

export enum OrgType {
  artist = 'artist',
  label = 'label',
}

export const useCurrentOrgOrNull = (): Org | null => {
  const location = useLocation();
  const match = matchPath<MatchType>(location.pathname, {
    path: [
      '/team/:orgType/:orgId',
      '/artist/:artistId',
      '/activity/:orgType/:orgId',
      '/add-artist',
      '/access/artist/:artistId',
    ],
  });
  const { artistId, orgType, orgId } = match
    ? match.params
    : { artistId: undefined, orgType: undefined, orgId: undefined };

  return useMemo(() => {
    if (!artistId && !orgType && !orgId) {
      return null;
    }

    const { type, id } = (() => {
      if (artistId) {
        return { type: OrgType.artist, id: artistId };
      } else if (orgType && orgId) {
        return {
          type: isOrgType(orgType) ? orgType : OrgType.artist,
          id: orgId,
        };
      }
      return { type: null, id: null };
    })();

    if (type === null || id === null) {
      return null;
    }

    return {
      type,
      id,
      uri: `spotify:${type}:${id}`,
    };
  }, [artistId, orgType, orgId]);
};

type MatchType = { orgType?: string; orgId?: string; artistId?: string };

export const isOrgType = (type: string): type is OrgType => type in OrgType;

export type Org = {
  type: OrgType;
  id: string;
  uri: string;
};
